<!--
Use ngx-loading-bar/http-client when load this page.
-->
<ngx-loading-bar [color]="'white'"></ngx-loading-bar>
<!-- / -->
<main class="w-full px-4">
  <div class="mx-auto max-w-7xl">
    <ng-container *ngIf="special?.id">
      <section class="z-10 relative">
        <ng-container *ngIf="special.url_banner_header != ''">
          <carousel class="carousel-html-content" [objectFit]="'cover'" [pauseOnFocus]="true" [cellWidth]="'100%'" [height]="350" [autoplay]="true" [dots]="true" [loop]="true">
            <div class="carousel-cell">
              <img loading="lazy" class="hidden sm:block cursor-pointer" src="{{special.url_banner_header}}" alt="{{special.name}}" />
            </div>
          </carousel>
        </ng-container>
      </section>

      <ng-container *ngIf="!special.special_is_valid">
        <div class="flex flex-col justify-center">
          <p class="text-pink-800 font-bold text-lg sm:text-3xl">{{special.name}}</p>
          <p class="font-semibold text-gray-800 py-1">A promoção que você está buscando não está ativa nesse momento.</p>
          <p class="text-sm text-gray-800">Encontre seus produtos utilizando o menu principal.</p>
        </div>
      </ng-container>

      <ng-container *ngIf="special.special_is_valid">
        <div class="py-8">
          <p class="text-pink-800 font-bold text-lg sm:text-3xl">{{special.name}}</p>
          <p class="font-semibold text-gray-800 py-1">Produtos incríveis por preços imbatíveis.</p>
          <p class="text-sm text-gray-800">{{special.body_description_short}}</p>
        </div>

        <ng-container *ngIf="relProducts?.total == 0">
          <p class="text-center py-8">Não existem produtos disponíveis.</p>
        </ng-container>
        <ng-container *ngIf="relProducts?.total > 0">
          <ng-container *ngIf="cart?.client_marketplace_cart_uid">
            <div class="py-4 sm:mx-auto">
              <div class="w-full overflow-x-auto no-scrollbar">
                <ul role="list" class="inline-flex space-x-8 sm:grid sm:grid-cols-4 sm:gap-x-4 sm:gap-y-6 sm:space-x-0">
                  <ng-container *ngFor="let product of relProducts.data">
                    <IncludeProductContainer [cart]="cart" [product]="product.product"></IncludeProductContainer>
                  </ng-container>
                </ul>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</main>
